import { useState, useEffect } from "react"
import QuantitySelector from "@/components/cart/QuantitySelector"
import DisplayDiscountPrice from "@/components/Shared/DisplayDiscountPrice"
import {
  getColors,
  getLineItemsProductImage,
} from "@/components/MyFavorites/v1/MyList/helper"
import { getPDPUrl } from "@/utils/helper"
import ColorSwatchSelected from "@/components/MyFavorites/v1/MyList/ColorSwatchSelected/v1/index.jsx"
import { getProductPrice } from "@/components/MyFavorites/v1/MyList/helper"
import cx from "classnames"
import Image from "@/components/Shared/Image"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import MissingImage from "@/public/images/image-missing.png"
import useWindowResize from "@/hooks/useWindowResize"
import { getPresetUrl } from "@/utils/index"

const ListRowItem = props => {
  const {
    general,
    siteName,
    productQtyObj,
    qtyChange,
    product,
    presetConfigs,
    handleCheckBoxChecked,
    checkedItems,
    handleProductView,
    listItemsPrice,
  } = props

  const {
    "productImages.url_ss": imageUrl,
    ProductBrandName_s: brandName,
    masterSKU_s: sku,
    ProductDescriptionProductShort_s: shortDescription,
  } = product
  const [tileUrl, setTileUrl] = useState("")

  const handleImageClick = e => {
    if (e.target.className && e.target.className !== "checkbox__marker-icon") {
      e.stopPropagation()
      e.preventDefault()
      handleProductView(brandName)
      location.href = decodeURIComponent(`${tileUrl}?skuId=${sku}`)
    }
  }

  const handleProductNameClick = () => {
    handleProductView(brandName)
    location.href = decodeURIComponent(`${tileUrl}?skuId=${sku}`)
  }

  useEffect(() => {
    const category = product.Product_Category
      ? product.Product_Category
      : product.ProductLocalCategory_s ?? ""
    getPDPUrl(category, product.slug_s).then(ret => setTileUrl(ret))
  }, [product])

  const [width] = useWindowResize()
  const colors = getColors(product)
  const images = getLineItemsProductImage(product)

  return (
    <div className="row list-item no-gutters">
      <div className="col-12 col-sm-6 mobile-full-width col-md-6 list-left ">
        <div className="list-item__summary">
          <a role="button" onClick={e => handleImageClick(e)}>
            <div className="list-image-tile">
              {imageUrl?.[0] && images?.length > 0 ? (
                images?.map((id, i) => {
                  const imgUrl = getPresetUrl(
                    width,
                    0,
                    general.swatchUrl,
                    id,
                    JSON.parse(presetConfigs)
                  )
                  return (
                    <img
                      className="list-image"
                      key={id + "_IMG_" + i}
                      id={id + "_IMG_" + i}
                      role="presentation"
                      src={imgUrl}
                      imgsrc={imgUrl}
                    />
                  )
                })
              ) : (
                <Image
                  className="list-image"
                  src={MissingImage}
                  alt="missing-image"
                />
              )}
              <div
                className="checkbox-on-tile"
                data-id={product["masterSKU_s"]}
              >
                <Checkbox
                  onChange={e =>
                    handleCheckBoxChecked(e, product["masterSKU_s"])
                  }
                  checked={checkedItems.includes(product["masterSKU_s"])}
                />
              </div>
            </div>
          </a>
          <section className="list-item__specs list-item__specs-tabs">
            <div className="row no-gutters">
              <div className="col-12 list-item-desc__name">
                <div
                  className={`${
                    colors && colors[0]?.name === "Not Applicable"
                      ? "visibilty"
                      : ""
                  }`}
                >
                  <ColorSwatchSelected
                    colors={colors}
                    cx={cx}
                    general={general}
                    mobile={true}
                  />
                </div>
                <div className="list-item__brand__list">
                  <span className="list-item__brand-name">
                    {siteName?.toUpperCase()}
                  </span>
                </div>
                <span
                  className="list-item__list-name"
                  onClick={handleProductNameClick}
                >
                  {brandName}
                </span>
                <p className="list-product-description-short">
                  {shortDescription}
                </p>
                <p className="list-product-description-short-sku">{sku}</p>
                {colors && colors[0]?.name === "Not Applicable" ? null : (
                  <ColorSwatchSelected
                    colors={colors}
                    cx={cx}
                    general={general}
                    mobile={false}
                  />
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="col-12 col-sm-6 col-md-6 list-item__info print-right">
        <div className="row list-item__qty-price cart-qty-price-mobile mx-0 px-0">
          <div className="col-4  list-item__discount-container discount-container-padding ">
            <div className="list-item__price">
              <span className="list-details-price hide-mobile-price">
                <DisplayDiscountPrice
                  formListDetails={true}
                  price={listItemsPrice[sku]}
                  discountedPrice={listItemsPrice[`${sku}-discount` ?? ""]}
                />
              </span>
            </div>
          </div>
          <div className="col-4 list-item__qty px-1">
            <div className="quantity-selector no-print small">
              <QuantitySelector
                size="small"
                value={productQtyObj[sku] ?? 1}
                onChange={value => qtyChange(value, product)}
              />
            </div>
          </div>
          <div className="col-4 text-right list-item__total px-0 hide-price-popup-mobile ">
            <span className="list-details-price hide-mobile-price">
              <DisplayDiscountPrice
                price={getProductPrice(product, productQtyObj, listItemsPrice)}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ListRowItem
